import { render, staticRenderFns } from "./TribeIcon.vue?vue&type=template&id=dd7bb05a"
import script from "./TribeIcon.vue?vue&type=script&lang=ts"
export * from "./TribeIcon.vue?vue&type=script&lang=ts"
import style0 from "./TribeIcon.vue?vue&type=style&index=0&id=dd7bb05a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports